import { setAmplitudeUserProperties } from "../../services/monitoring";
import { fetchVariant } from "../../services/whoop-experiments";
import { createContext, useContext, useEffect, useState } from "react";

const StatusPageContext = createContext(null);

export const StatusPageProvider = ({ children }) => {
  const [isInAftershipTrackingExperiment, setIsInAftershipTrackingExperiment] =
    useState(null);
  const [errorFromOrderLookUpService, setErrorFromOrderLookUpService] =
    useState();
  const [userTypedOrderId, setUserTypedOrderId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const variant = await fetchVariant({
        name: "aftership-tracking-experiment",
      }).finally(() => {
        setIsLoading(false);
      });

      if (variant !== null) {
        setAmplitudeUserProperties({
          "aftership-tracking-experiment": variant,
        });
      }
      const isInExperiment = variant === "experiment";
      const shouldCallOrderLookUpService = !isInExperiment;
      setIsInAftershipTrackingExperiment(variant === "experiment");
    })();
  }, []);

  return (
    <StatusPageContext.Provider
      value={{
        isInAftershipTrackingExperiment,
        setIsInAftershipTrackingExperiment,
        errorFromOrderLookUpService,
        setErrorFromOrderLookUpService,
        userTypedOrderId,
        setUserTypedOrderId,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </StatusPageContext.Provider>
  );
};

export const useStatusPage = () => {
  const context = useContext(StatusPageContext);
  if (!context) {
    throw new Error("useStatusPage must be used within a StatusPageProvider");
  }
  return context;
};
